import EmailRow from './EmailRow';

export default EmailRow;
